import * as React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { Layout } from 'antd';
import UserSideNav from "./UserSideNav";
import '../Layout.less';
import 'src/pages/public/Public.less';
import GeneralHeader from "src/layouts/GeneralHeader";

const { Content } = Layout;

class UserLayout extends React.Component<{}, {}> {
    render() {
        return <Layout>
            <GeneralHeader
                renderEmulationBanner={false}
                renderFullscreenToggle={true}
                renderLanguageToggle={true}
                renderAudioToggle={false}
                renderPlanetBox={false}
                renderBackToSpaceStation={true}
            />
            <Layout className="has-side-nav">
                <UserSideNav />
                <Content>
                    {this.props.children}
                </Content>
            </Layout>
        </Layout>;
    }
}

export default UserLayout;



// WEBPACK FOOTER //
// ./src/layouts/user/UserLayout.tsx